import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { beforeItems, afterItems, transformationBadges } from '../data/kit';
export function TransformationSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-159" data-mp="2wx4bztf1pat6">
      <div className="max-w-5xl mx-auto" data-id="element-160" data-mp="2wvsyh1vssoov">
        <div className="flex flex-col md:flex-row gap-12 items-center mb-16" data-id="element-161" data-mp="2rysz19tgek6q">
          <div className="flex-1" data-id="element-162" data-mp="2s0x6u2uh43ca">
            <h2 className="text-4xl md:text-5xl font-black text-brand-text leading-[1.1] tracking-tight mb-6 text-balance" data-id="element-163" data-mp="2nx7fj5mez7nk">
              De una profesora sobrecargada a una{' '}
              <span className="italic text-brand-green" data-id="element-164" data-mp="2e6wbzk6n70h7">guía inspirada.</span>
            </h2>
            <div className="inline-flex items-center gap-4 bg-white/70 p-4 rounded-2xl" data-id="element-165" data-mp="298bbrkre4gsr">
              <span className="text-4xl font-serif font-bold text-brand-terracotta" data-id="element-166" data-mp="248ypp28cfdr8">
                3.800+
              </span>
              <span className="text-sm text-brand-gray font-medium max-w-[150px] leading-tight" data-id="element-167" data-mp="2074rd0lmelu8">
                horas ahorradas al año en planificación.
              </span>
            </div>
          </div>

          <div className="flex-1 w-full bg-white rounded-3xl shadow-sm border border-brand-creamDark grid grid-cols-2 overflow-hidden" data-id="element-168" data-mp="k2ubtmbd496f">
            <div className="bg-brand-terracottaSoft p-5 md:p-7" data-id="element-169" data-mp="5atitg7mflsg">
              <div className="flex items-center gap-2 mb-6" data-id="element-170" data-mp="ad108lb7zu26">
                <XCircleIcon className="w-6 h-6 text-brand-terracotta shrink-0" aria-hidden="true" data-id="element-171" data-mp="y1torwpiizmr" />
                <h3 className="text-xs md:text-sm font-bold uppercase tracking-wider text-brand-terracotta leading-tight" data-id="element-172" data-mp="130506bvghi73">
                  Antes
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-173" data-mp="t15yxed0sou4">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5 text-brand-text" data-id="element-174" data-mp="39q1oouojopsc">
                    <XCircleIcon className="w-5 h-5 text-brand-terracotta/70 shrink-0 mt-0.5" aria-hidden="true" data-id="element-175" data-mp="3dqd864568k28" />
                    <span className="text-sm md:text-base font-medium leading-snug" data-id="element-176" data-mp="1fbo6i53hvh7x">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-brand-greenSoft p-5 md:p-7 border-l border-brand-creamDark" data-id="element-177" data-mp="15j07r4syf36k">
              <div className="flex items-center gap-2 mb-6" data-id="element-178" data-mp="11hepf3xnhwoz">
                <CheckCircle2Icon className="w-6 h-6 text-brand-green shrink-0" aria-hidden="true" data-id="element-179" data-mp="wjd6qk44zze1" />
                <h3 className="text-xs md:text-sm font-bold uppercase tracking-wider text-brand-green leading-tight" data-id="element-180" data-mp="rn4vhht28qc5">
                  Con Yoga Lista
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-181" data-mp="2lwyukk2vnqzb">
                {afterItems.map(item => <li key={item} className="flex items-start gap-2.5 text-brand-text" data-id="element-182" data-mp="2gy5f4m415pwi">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-green shrink-0 mt-0.5" aria-hidden="true" data-id="element-183" data-mp="2tic8mxh3wspp" />
                    <span className="text-sm md:text-base font-semibold leading-snug" data-id="element-184" data-mp="338njz534e46m">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-185" data-mp="2akrf3d3ed5yr">
          {transformationBadges.map(badge => <div key={badge.label} className="bg-white px-6 py-3 rounded-full shadow-sm border border-brand-creamDark flex flex-col items-center" data-id="element-186" data-mp="2fhrmbrbzgerg">
              <span className="font-serif font-bold text-xl text-brand-text" data-id="element-187" data-mp="3qxpyw56ddixf">
                {badge.value}
              </span>
              <span className="text-[10px] uppercase tracking-wider text-brand-gray" data-id="element-188" data-mp="3vz5nu8bo49l3">
                {badge.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}